/* global G */

const confirm = obj => (...args) => obj[G.ADAPTER][G.ROUTER].confirm(args)

export default confirm
